import React, { useEffect } from 'react';
import { service, factories } from 'powerbi-client';
import usePBIEmbedded from 'app/usePBIEmbedded';
import { usePbiStore } from 'context/PBIContext';
import { ReportContainer } from 'components/Syles';
import SpinnerLoaderComponent from 'components/loader/SpinnerLoader';
import { ApiEndpoints } from 'api/apiEndpointUtils';
import useApiLoaderHelper from 'hooks/useApiLoaderHelper';

const powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);

const Statistics: React.FC = () => {
    const pageName = 'ReportSectionfffa63b1fdaee422ebb4';
    const reportContainerId = 'portOperationsPBIContainer';
    const { getEmbeddedConfiguration } = usePBIEmbedded();
    const { pbiAccessToken } = usePbiStore();
    const { isLoadingType } = useApiLoaderHelper();
    const isLoadingPbiAccessToken = isLoadingType(ApiEndpoints.getPowerBiEmdeddedToken);

    useEffect(() => {
        const embedContainer = document.getElementById(reportContainerId);
        if (!embedContainer || !pbiAccessToken) return;

        const embedConfiguration = getEmbeddedConfiguration(pbiAccessToken, pageName);

        powerbi.reset(embedContainer);
        powerbi.embed(embedContainer, embedConfiguration);
    }, [pbiAccessToken]);

    if (isLoadingPbiAccessToken) {
        return (
            <>
                <SpinnerLoaderComponent showOverlay={true}></SpinnerLoaderComponent>
            </>
        );
    }
    return <>{pbiAccessToken && <ReportContainer id={reportContainerId}></ReportContainer>}</>;
};

export default Statistics;
